import getMessagesForNamespaces from "@lib/i18n/getMessagesForNamespaces";
import Shipping from "@components/views/Profile/Addresses/Shipping";

const ShippingPage = () => <Shipping />;

export async function getServerSideProps({ params: { locale } }) {
  return {
    props: {
      ...(await getMessagesForNamespaces(locale, [
        "common",
        "addresses",
        "accounts",
        "address_form",
      ])),
    },
  };
}

export default ShippingPage;
